// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2jCcI","description":"PatientConsentPreview_description__3SkyH"};